import { Pipe, PipeTransform } from '@angular/core';

import { ColumnDataType } from '@blaze-shared/api-contracts-domain';
import { BlazeTable } from '@blaze-shared/datasets-domain';
import { ColumnType } from '@blaze-shared/schema-domain';

@Pipe({
  name: 'datasetLabel',
  standalone: false,
})
export class DatasetLabelPipe implements PipeTransform {
  transform(dataset: BlazeTable): string {
    return dataset.connectorName ? `${dataset.connectorName}/${dataset.name}` : dataset.name;
  }
}

const SHOULD_HIDE_REQUIRED_SWITCH: ColumnType[] = [
  'AutoNumber',
  'CreatedBy',
  'CreatedTime',
  'Formula',
  'LastUpdatedTime',
  'Rollup',
  'UpdatedBy',
];

@Pipe({
  name: 'isRequiredUniqueAvailable',
  standalone: false,
})
export class IsRequiredUniqueAvailablePipe implements PipeTransform {
  transform(type: ColumnType | undefined): boolean {
    if (!type) {
      return false;
    }
    return !SHOULD_HIDE_REQUIRED_SWITCH.includes(type);
  }
}

const SHOULD_HIDE_UNIQUE_SWITCH: ColumnType[] = [
  'AccessRole',
  'Boolean',
  'Duration',
  'File',
  'GeoPoint',
  'Image',
  'Link',
  'Rollup',
  'SecureText',
  'Signature',
  'Tag',
  'Time',
];

@Pipe({
  name: 'shouldShowUniqueSwitch',
  standalone: false,
})
export class ShouldShowUniqueSwitchPipe implements PipeTransform {
  transform(columnType: ColumnType | undefined): boolean {
    return !!columnType && !SHOULD_HIDE_UNIQUE_SWITCH.includes(columnType);
  }
}

const NO_DEFAULT_VALUE_DATA_TYPE: ColumnDataType[] = [
  'Array',
  'File',
  'Image',
  'Object',
  'Signature',
  'Rollup',
];

@Pipe({
  name: 'canDataTypeHaveDefaultValue',
  standalone: false,
})
export class CanDataTypeHaveDefaultValuePipe implements PipeTransform {
  transform(columnDataType: ColumnDataType | undefined): boolean {
    return !!columnDataType && !NO_DEFAULT_VALUE_DATA_TYPE.includes(columnDataType);
  }
}

const NO_DEFAULT_VALUE_COLUMN_TYPE: ColumnType[] = ['Formula', 'GeoPoint'];

@Pipe({
  name: 'canColumnTypeHaveDefaultValue',
  standalone: false,
})
export class CanColumnTypeHaveDefaultValuePipe implements PipeTransform {
  transform(columnType: ColumnType | undefined): boolean {
    return !!columnType && !NO_DEFAULT_VALUE_COLUMN_TYPE.includes(columnType);
  }
}
